import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Response } from '@shared/interfaces/response/response';
import { Promociones, IPromocionErrRequest, IPromocionErrResponse } from '@p-p-portafolio/interfaces/promociones';
import { ICampClteList } from '@p-p-portafolio/promociones/interfaces/IPromociones';
import { IGetAllPromCopy, IGetAllPromCopyRes } from '@p-p-portafolio/promociones/promociones-component/promociones-copy/promociones-copy.component';
import { IGetPromcionCopi, IGetPromcionCopiRes } from '@p-p-portafolio/promociones/interfaces/IGetPromcionCopi';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({ providedIn: 'root' })
export class PromocionesService {
  private _url = environment.apiBaseUrl + 'api/parametria/portafolio/promociones/';

  constructor(private _http: HttpClient) {}

  create(model: Promociones): Observable<Response> {
    return this._http.post<Response>(this._url, model, httpOption);
  }

  read(): Observable<Response> {
    return this._http.get<Response>(this._url);
  }

  update(model: Promociones): Observable<Response> {
    return this._http.put<Response>(this._url, model, httpOption);
  }

  delete(model: Promociones): Observable<Response> {
    return this._http.request<Response>('delete', this._url, {
      body: model
    });
  }

  readOne(sPromcion: string): Observable<Response> {
    let url: string = this._url + sPromcion;
    return this._http.get<Response>(url);
  }

  getClaseCartera(sUsuario: string): Observable<ICampClteList> {
    return this._http.post<ICampClteList>(environment.apiNewBackBaseUrl + 'Solicitudes/ValoresPromocion', {
      sUsuario: sUsuario,
      iTipo: 0
    });
  }

  getCnsltTpCartera() {
    return this._http.post<any>(environment.apiNewBackBaseUrl + 'Promociones/GetCnsltTpCartera', {
      tope: '999'
    });
  }

  getGastos() {
    return this._http.post<any>(environment.apiNewBackBaseUrl + 'Gastos/GetGastos', {
      limit: '999'
    });
  }

  GetAll() {
    return this._http.post<IGetAllPromCopyRes>(environment.apiNewBackBaseUrl + 'Promociones/GetAll', { limit: '999' });
  }

  GetPromcionCopi(payload: IGetPromcionCopi) {
    return this._http.post<IGetPromcionCopiRes>(environment.apiNewBackBaseUrl + 'Promociones/GetPromcionCopi', payload);
  }

  createPromocionErr(payload: IPromocionErrRequest): Observable<IPromocionErrResponse> {
    return this._http.post<IPromocionErrResponse>(environment.apiNewBackBaseUrl + 'Promociones/GetPromcionErr', payload);
  }
}
